import { render, staticRenderFns } from "./DirectPurchaseModal.vue?vue&type=template&id=0a78d0ef&scoped=true&"
import script from "./DirectPurchaseModal.vue?vue&type=script&lang=js&"
export * from "./DirectPurchaseModal.vue?vue&type=script&lang=js&"
import style0 from "./DirectPurchaseModal.vue?vue&type=style&index=0&id=0a78d0ef&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a78d0ef",
  null
  
)

export default component.exports